import { z } from 'zod';
import { SUPPORTED_LOCALES } from '../constants/app.js';
import { currencyCodeSchema, idSchema, isoDateSchema, isoDateTimeSchema } from './common.js';
import { supportedLocaleSchema } from './plm-material.js';
const priceGroupTranslationsSchema = z.record(supportedLocaleSchema, z.string().trim().min(1).max(160));
export const priceGroupWriteSchema = z
    .object({
    code: z.string().trim().min(1).max(50),
    name: z.string().trim().min(1).max(160),
    description: z.string().trim().max(2000).nullable().default(null),
    translations: priceGroupTranslationsSchema.default({}),
    currency: currencyCodeSchema.nullable().default(null),
    sortOrder: z.number().int().min(0).max(10000).default(0),
    isActive: z.boolean().default(true),
})
    .strict();
/** Setup price lists use localized name/description objects; old integrations may use strings. */
export function priceGroupTranslations(value) {
    const entries = z.record(z.unknown()).safeParse(value).data ?? {};
    return Object.fromEntries(SUPPORTED_LOCALES.flatMap((locale) => {
        const entry = entries[locale];
        const name = typeof entry === 'string'
            ? entry
            : z.object({ name: z.string() }).safeParse(entry).data?.name;
        return name?.trim() ? [[locale, name]] : [];
    }));
}
export const priceGroupSchema = priceGroupWriteSchema.strip().extend({
    id: idSchema,
    code: z.string(),
    translations: z.preprocess(priceGroupTranslations, priceGroupTranslationsSchema),
    customerCount: z.number().int().nonnegative(),
    productCount: z.number().int().nonnegative(),
    needsReview: z.boolean(),
    legacyValues: z.array(z.string()),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const priceGroupListSchema = z.object({ data: z.array(priceGroupSchema) });
export function priceGroupLabel(group, locale) {
    return Object.entries(group.translations).find(([key]) => key === locale)?.[1] ?? group.name;
}
export const priceGroupSnapshotSchema = z.object({
    id: idSchema,
    code: z.string(),
    name: z.string(),
    currency: currencyCodeSchema.nullable(),
});
export const priceConditionSourceSchema = z.enum(['GROUP', 'GENERAL', 'LIST', 'CUSTOMER']);
export const priceResolutionSnapshotSchema = z.object({
    priceGroupId: idSchema.nullable(),
    source: z.enum(['LIST', 'TIER']),
    conditionSource: priceConditionSourceSchema.optional(),
    validFrom: isoDateSchema.nullish(),
    validTo: isoDateSchema.nullish(),
    tierId: idSchema.nullable(),
    currency: currencyCodeSchema,
    referenceDate: z.string(),
    quantityBase: z.string(),
    baseUnit: z.string(),
    unitPrice: z.string(),
    discountPct: z.string(),
    minQuantity: z.string().nullable(),
});
//# sourceMappingURL=price-group.js.map